export function Logo({ size = 44, showText = true, className = "" }) {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <img src="/loewenstark-lion.png" alt="Löwenstark" style={{ height: size }} className="object-contain drop-shadow-[0_4px_18px_rgba(212,175,55,0.25)]" />
      {showText && (
        <img src="/loewenstark-wordmark-light.png" alt="LÖWENSTARK" style={{ height: size * 0.28 }} className="mt-2 object-contain" />
      )}
    </div>
  );
}

export function LogoRow({ className = "", compact = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <img src="/loewenstark-lion.png" alt="Löwenstark" className="h-9 w-9 object-contain" />
      <img src="/loewenstark-wordmark-light.png" alt="LÖWENSTARK" className={`h-3.5 object-contain ${compact ? "hidden lg:block" : ""}`} />
    </div>
  );
}

